import { useIntl } from 'react-intl';
import { Help } from '@clds/icon';
import { MENU_ITEM_ICON_SIZE } from '../../ApplicationWrapper.const';
import { messages } from '../../i18n';
import { PrimaryMenuItemDropdownMenu } from '../PrimaryMenuItemDropdownMenu/PrimaryMenuItemDropdownMenu';
import { HelpDropdownMenuItems } from './HelpDropdownMenuItems';

export const HelpDropdownMenu = () => {
  const { formatMessage } = useIntl();

  return (
    <PrimaryMenuItemDropdownMenu
      size={undefined}
      items={<HelpDropdownMenuItems />}
      analyticsMessage="help menu"
      tooltipTitle={formatMessage(messages.helpMenuTooltip)}
      dataTestSpecifier="help-menu"
    >
      <Help size={MENU_ITEM_ICON_SIZE} />
    </PrimaryMenuItemDropdownMenu>
  );
};
